// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1384":"ImageGallery-Chunk","1628":"DownloadCards-Chunk","7131":"ContentCards-Chunk","8909":"Campaign-Chunk"}[chunkId] + ".min.css";
};